<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<graph-info-search-view search-container ref="GraphInfoSearchView" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<graph-info-table-view ref="table" @rePortPopOpen="rePortPopOpen" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->

			<!-- 그래프 부분 시작 -->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<graph-info-graph-view ref="graph" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 그래프 부분 끝 -->
			<!-- 폼 부분 시작 -->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<form-view
						:scrId="scrId"
						@PopupOpen="PopupOpen"
						@CarSalePopupOpen="CarSalePopupOpen"
						@CpnyPopupOpen="CpnyPopupOpen"
						:partNo="partNo"
						:partNoInput="partNoInput"
						:pmcId="pmcId"
						:pmcIdInput="pmcIdInput"
						:sendCpnyParam="sendCpnyParam"
					></form-view>
					<!-- <graph-info-graph-view ref="graph" @Refresh="Refresh" :scrId="scrId" /> -->
				</sf-card>
			</div>
			<!-- 폼 부분 끝 -->
			<!-- 팝업부분 영역 시작 -->
			<part-popup ref="partPopup" @SendPartData="sendPartData" @Refresh="Refresh" :scrId="scrId" />
			<car-sale-popup ref="carSalePopup" @SendPmcData="sendPmcData" @Refresh="Refresh" :scrId="scrId" />
			<cpny-popup ref="cpnyPopup" @SendCpnyData="sendCpnyData" @Refresh="Refresh" :scrId="scrId" />
			<!-- 레포트팝업 -->
			<report-popup ref="reportPopup" :scrId="scrId" />
			<!-- 팝업부분 영역 종료 -->
		</div>
	</div>
</template>

<script>
import CarSalePopup from '@qms/comm/commpopup/CarSalePopup/CarSalePopup.vue';
import PartPopup from '@qms/comm/commpopup/PartPopup/PartPopup.vue';
import CpnyPopup from '@qms/comm/commpopup/CpnyPopup/CpnyPopup.vue';
import GraphInfoSearchView from './Search/GraphInfoSearchView.vue';
import GraphInfoTableView from './Table/GraphInfoTableView.vue';
import GraphInfoGraphView from './Table/GraphInfoGraphView.vue';
import FormView from './Table/FormView.vue';
import reportPopup from '@qms/Components/popup/ReportPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			partNo: '',
			partNoInput: '',
			pmcId: '',
			pmcIdInput: '',
			partScnInput: '',
			sendCpnyParam: {}
		};
	},
	created() {
		console.clear();
	},
	components: { GraphInfoSearchView, GraphInfoTableView, GraphInfoGraphView, FormView, PartPopup, CarSalePopup, CpnyPopup, reportPopup },
	methods: {
		Refresh(currentPage = 1, pageUnit = 30) {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.graphInfoSearchView.searchList(currentPage, pageUnit);
			this.$refs.partPopup.searchList(currentPage, pageUnit);
		},
		PopupOpen(param) {
			this.$refs.partPopup.open(param); //.open(param);
		},
		CarSalePopupOpen(param) {
			this.$refs.carSalePopup.open(param); //.open(param);
		},
		CpnyPopupOpen(param) {
			//console.log('자식->부모param::::::', param);
			this.$refs.cpnyPopup.open(param); //.open(param);
		},
		sendPartData(param) {
			this.partNo = param.partNo;
		},
		sendPmcData(param) {
			//console.log('param::', param);
			this.pmcId = param.pmcId;
		},
		sendCpnyData(param) {
			this.sendCpnyParam = param;
		},
		rePortPopOpen(params) {
			//console.log('리포트 공통파일 호출', params);
			this.$refs.reportPopup.openWindowReport(params);
		}
	}
};
</script>

<style></style>
